module.exports = __webpack_public_path__ + "assets/691aa7df33f18087acf60d10aaefef8a.mp4";